import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-footer',
  templateUrl: './section-footer.component.html',
  styleUrls: ['./section-footer.component.css']
})
export class SectionFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
